var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: [
        "border border-solid border-faint-grey rounded",
        "px-2 pb-2 pt-1",
        "flex flex-col"
      ]
    },
    [
      _vm._l(_vm.value.children, function(child, pos) {
        return [
          _vm.debug
            ? _c("label", { key: pos, staticClass: "text-danger font-bold" }, [
                _vm._v(_vm._s(pos) + " - " + _vm._s(child.name))
              ])
            : _vm._e(),
          !child.component
            ? [
                !_vm.isSubField(child)
                  ? _c("div", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.shouldShow(child.name),
                          expression: "shouldShow(child.name)"
                        }
                      ],
                      key: child.name,
                      class: [
                        "border-solid border-t-0 border-r-0 border-l-0 border-b border-faint-grey my-1 shadow-drop"
                      ],
                      staticStyle: {
                        "margin-left": "-1.5rem",
                        "margin-right": "-1.5rem"
                      }
                    })
                  : _vm._e(),
                _c(
                  "transition",
                  { key: child.name, attrs: { name: "fade" } },
                  [
                    _c("formulate-field-adapter", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.shouldShow(child.name),
                          expression: "shouldShow(child.name)"
                        }
                      ],
                      key: child.name,
                      class: {
                        "mb-2": !_vm.isSubField(_vm.value.children[pos + 1])
                      },
                      attrs: { disabled: _vm.disabled, field: child },
                      on: { mounted: _vm.emitField }
                    })
                  ],
                  1
                )
              ]
            : _c(child.component, { key: child.name, tag: "component" }, [
                _c("div", {
                  directives: [
                    {
                      name: "html-safe",
                      rawName: "v-html-safe",
                      value: child.children,
                      expression: "child.children"
                    }
                  ]
                })
              ])
        ]
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }